<template>
    <div class="pm-page">
  
      <!-- ============ HERO / BANNIÈRE ============ -->
      <header class="pm-hero">
        <picture>
          <source
            srcset="../../public/img/theme/tricycle/tricycleInf.webp 800w, ../../public/img/theme/telephone.jpg 1600w"
            type="image/webp"
          />
          <img
            src="../../public/img/theme/tricycle/tricycleInf.webp"
            alt="Panneau publicitaire mobile installé sur un tricycle dans les rues de Cotonou, Bénin la nuit pour l'Institut Nationale de la Femme INF"
            class="pm-hero__bg"
            width="1600"
            height="900"
            fetchpriority="high"
          />
        </picture>
  
        <div class="pm-hero__panel" role="presentation">
          <span class="pm-hero__bolt pm-hero__bolt--tl" aria-hidden="true"></span>
          <span class="pm-hero__bolt pm-hero__bolt--tr" aria-hidden="true"></span>
          <span class="pm-hero__bolt pm-hero__bolt--bl" aria-hidden="true"></span>
          <span class="pm-hero__bolt pm-hero__bolt--br" aria-hidden="true"></span>
  
          <p class="pm-hero__eyebrow">RÉSEAU PUBLICITAIRE — BÉNIN</p>
          <h1 class="pm-hero__title">
            Votre marque,<br />partout où la ville regarde.
          </h1>
          <p class="pm-hero__subtitle">
            Panneau Mobile conçoit et exploite {{ supports.length }} formats d'affichage
            publicitaire à Cotonou et dans d'autres villes du Bénin&nbsp;: vélo publicitsaire, véhicules,
            façades, carrefours, mototaxis, moving board...
          </p>
          <a href="#supports" class="pm-btn pm-btn--primary">Voir les supports disponibles</a>
        </div>
      </header>
  
      <main class="pm-main">
  
        <!-- ============ INTRO ============ -->
        <section class="pm-intro" aria-labelledby="intro-title">
          <h2 id="intro-title" class="pm-section-title">Un support pour chaque objectif</h2>
          <p class="pm-intro__text">
            Chaque support est vendu avec ses propres dimensions, son audience type
            et sa zone de diffusion. Comparez-les ci-dessous ou demandez un devis
            personnalisé pour votre campagne.
          </p>
        </section>
  
        <!-- ============ GRILLE DES SUPPORTS ============ -->
        <section id="supports" class="pm-supports" aria-labelledby="supports-title">
          <h2 id="supports-title" class="pm-section-title">Nos supports publicitaires</h2>
  
          <div class="pm-grid">
            <article
              v-for="support in supports"
              :key="support.id"
              class="pm-card"
              :id="support.slug"
              itemscope
              itemtype="https://schema.org/Product"
            >
              <div class="pm-card__media">
                <img
                  :src="support.image"
                  :alt="support.imageAlt"
                  width="640"
                  height="420"
                  loading="lazy"
                  itemprop="image"
                />
              </div>
  
              <div class="pm-card__body">
                <h3 class="pm-card__title" itemprop="name">{{ support.name }}</h3>
                <p class="pm-card__tagline">{{ support.tagline }}</p>
                <p class="pm-card__desc" itemprop="description">{{ support.description }}</p>
  
                <meta itemprop="brand" content="Panneau Mobile" />
                <meta itemprop="category" content="Publicité extérieure" />
  
                <a
                  :href="support.path"
                  class="pm-btn text-center pm-btn--secondary"
                >
                  En savoir plus
                </a>
              </div>
            </article>
          </div>
        </section>
  
        <!-- ============ FAQ (SEO longue traîne) ============ -->
        <section class="pm-faq" aria-labelledby="faq-title">
          <h2 id="faq-title" class="pm-section-title">Questions fréquentes</h2>
          <div
            v-for="(item, index) in faq"
            :key="index"
            class="pm-faq__item"
          >
            <h3 class="pm-faq__question">{{ item.question }}</h3>
            <p class="pm-faq__answer">{{ item.answer }}</p>
          </div>
        </section>
  
        <!-- ============ CTA FINAL ============ -->
        <section class="pm-cta">
          <h2 class="pm-section-title pm-section-title--light">
            Prêt à lancer votre campagne&nbsp;?
          </h2>
          <p class="pm-cta__text">
            Décrivez votre objectif, votre budget et votre zone cible&nbsp;: nous vous
            recommandons le support le plus adapté sous 24h.
          </p>
          <a href="/contact" class="pm-btn pm-btn--primary">Demander un devis gratuit</a>
        </section>
  
      </main>
    </div>
  </template>
  
  <script>
    import mooving from "../../public/img/theme/movingboard_.jpeg";
    import journal from "../../public/img/theme/celtiis/journal.jpeg";
    import zem from "../../public/img/theme/zem/zemPub.jpg";
    import velo from "../../public/img/theme/velopic.jpg";
    import telephone from "../../public/img/theme/tricycle/infTricycleJour.webp";
    import gillet from "../../public/img/theme/gillet/gilletPub.png";
    import drapeau from "../../public/img/theme/drapeau/drapeauLnb.jpg";
    import auto from "../../public/img/theme/auto/busJah.jpg";
    import distribution from "../../public/img/theme/flyers/distribution.webp";

  export default {
    name: 'ProductSupportsPage',
  
    data() {
      return {
        supports:[
            {
                "id": 1,
                "slug": "velo-publicitaire",
                "ref": "PM-01",
                "name": "Vélo Publicitaire (lumineux)",
                "tagline": "Affichage de proximité, écologique et visible même la nuit",
                "description": "Vélo équipé d'un panneau publicitaire rétroéclairé, conduit par un agent qui parcourt quartiers, marchés et zones piétonnes. L'éclairage LED prolonge la visibilité du message après la tombée de la nuit.",
                "image": velo,
                "imageAlt": "Vélo publicitaire équipé d'un panneau lumineux circulant dans une rue de Cotonou",
                "specs": [
                { "label": "Format", "value": "1,2 m × 0,8 m" },
                { "label": "Éclairage", "value": "Panneau LED rétroéclairé" },
                { "label": "Durée min.", "value": "7 jours" },
                { "label": "Zone", "value": "Quartier(s) au choix" }
                ],
                "ctaLabel": "Réserver ce support",
                "path": "/velo-publicitaire-benin"
            },
            {
                "id": 2,
                "slug": "movingboard",
                "ref": "PM-02",
                "name": "Movingboard (sac à dos publicitaire lumineux)",
                "tagline": "Un panneau qui marche au milieu de la foule",
                "description": "Sac à dos rigide intégrant un panneau publicitaire lumineux, porté par un agent qui se déplace à pied dans les zones très fréquentées : marchés, événements, sorties d'écoles ou de bureaux.",
                "image": mooving,
                "imageAlt": "Agent portant un sac à dos publicitaire lumineux de type Movingboard",
                "specs": [
                { "label": "Format", "value": "0,7 m × 0,5 m (porté dos)" },
                { "label": "Éclairage", "value": "LED intégrée" },
                { "label": "Durée min.", "value": "1 jour (événementiel) / 7 jours (campagne)" },
                { "label": "Zone", "value": "Marchés, événements, zones piétonnes denses" }
                ],
                "ctaLabel": "Réserver ce support",
                "path": "/moving-board-benin"
            },
            {
                "id": 3,
                "slug": "tricycle-publicitaire",
                "ref": "PM-03",
                "name": "Tricycle Publicitaire (lumineux)",
                "tagline": "Plus de surface d'affichage, toujours aussi mobile",
                "description": "Tricycle aménagé avec un large panneau publicitaire lumineux sur les côtés et/ou l'arrière. Plus stable et plus visible qu'un vélo, il permet aussi le transport de flyers ou d'échantillons à distribuer.",
                "image": telephone,
                "imageAlt": "Tricycle publicitaire avec panneau lumineux circulant en ville",
                "specs": [
                { "label": "Format", "value": "1,8 m × 1,2 m" },
                { "label": "Éclairage", "value": "Panneau LED rétroéclairé" },
                { "label": "Durée min.", "value": "7 jours" },
                { "label": "Option", "value": "Espace de transport pour flyers/échantillons" }
                ],
                "ctaLabel": "Réserver ce support",
                "path": "/contact"
            },
            {
                "id": 4,
                "slug": "journal-geant",
                "ref": "PM-04",
                "name": "Journal Géant",
                "tagline": "Le format éditorial qui capte l'attention",
                "description": "Reproduction grand format d'une une de journal mettant en scène votre marque ou votre offre, affichée ou portée dans des zones à fort passage. Un format qui intrigue et incite à la lecture.",
                "image": journal,
                "imageAlt": "Affichage publicitaire en format journal géant dans un lieu public",
                "specs": [
                { "label": "Format", "value": "2 m × 1,4 m" },
                { "label": "Support", "value": "Panneau rigide ou bâche" },
                { "label": "Durée min.", "value": "7 jours" },
                { "label": "Usage type", "value": "Lancement de produit, annonce, campagne d'image" }
                ],
                "ctaLabel": "Réserver ce support",
                "path": "/contact"
            },
            {
                "id": 5,
                "slug": "drapeau-mobile",
                "ref": "PM-05",
                "name": "Drapeau Mobile",
                "tagline": "Visible de loin, idéal pour signaler un point précis",
                "description": "Drapeau publicitaire porté ou installé sur un support mobile, utilisé pour signaler un événement, un point de vente temporaire ou guider le public vers un lieu précis.",
                "image": drapeau,
                "imageAlt": "Drapeau publicitaire mobile utilisé lors d'un événement",
                "specs": [
                { "label": "Format", "value": "1 m × 2,5 m (hauteur)" },
                { "label": "Mode", "value": "Porté à pied ou fixé sur véhicule" },
                { "label": "Durée min.", "value": "1 jour" },
                { "label": "Usage type", "value": "Événementiel, inauguration, signalisation ponctuelle" }
                ],
                "ctaLabel": "Réserver ce support",
                "path": "/contact"
            },
            {
                id: 9,
                slug: 'habillage-zemidjan',
                ref: 'PM-04',
                name: 'Habillage Zémidjan',
                tagline: "Au plus près du quotidien des Béninois",
                description:
                    "Marquage publicitaire sur gilets ou habillage de mototaxis (zémidjans). Un support mobile, économique et ultra-localisé qui circule dans les quartiers populaires toute la journée.",
                image: zem,
                imageAlt: 'Mototaxi zémidjan avec gilet publicitaire à Cotonou',
                specs: [
                    { label: 'Format', value: 'Gilet ou habillage moto' },
                    { label: 'Flotte', value: 'À partir de 20 conducteurs' },
                    { label: 'Durée min.', value: '1 mois' },
                    { label: 'Zone', value: 'Quartiers ciblés au choix' },
                ],
                ctaLabel: 'Réserver ce support',
                "path": "/contact"
            },
            {
                "id": 6,
                "slug": "vehicule-publicitaire",
                "ref": "PM-06",
                "name": "Véhicule Publicitaire",
                "tagline": "Votre marque roule dans toute la ville",
                "description": "Véhicule habillé ou équipé d'un panneau publicitaire, circulant selon un itinéraire défini. Permet de couvrir rapidement plusieurs quartiers et grands axes en une seule campagne.",
                "image": auto,
                "imageAlt": "Véhicule publicitaire circulant dans les rues de Cotonou",
                "specs": [
                { "label": "Format", "value": "4 m × 2,5 m" },
                { "label": "Couverture", "value": "Itinéraire personnalisable" },
                { "label": "Durée min.", "value": "7 jours" },
                { "label": "Visibilité", "value": "Jour et nuit (éclairage en option)" }
                ],
                "ctaLabel": "Réserver ce support",
                "path": "/contact"
            },
            {
                "id": 7,
                "slug": "gilet-ecran-led",
                "ref": "PM-07",
                "name": "Gilet à Écran LED",
                "tagline": "Le message qui bouge avec la personne qui le porte",
                "description": "Gilet équipé d'un écran LED diffusant texte, visuels ou animations, porté par un agent en déplacement. Le contenu peut être modifié à distance pour s'adapter en temps réel à votre message.",
                "image": gillet,
                "imageAlt": "Agent portant un gilet publicitaire à écran LED",
                "specs": [
                { "label": "Format", "value": "Écran LED porté, 0,5 m × 0,4 m" },
                { "label": "Diffusion", "value": "Texte et visuels animés, en boucle" },
                { "label": "Durée min.", "value": "1 jour" },
                { "label": "Mise à jour", "value": "Contenu modifiable à distance" }
                ],
                "ctaLabel": "Réserver ce support",
                "path": "/contact"
            },
            {
                "id": 8,
                "slug": "distribution-flyers",
                "ref": "PM-08",
                "name": "Distribution de Flyers",
                "tagline": "Le contact direct avec votre client final",
                "description": "Équipe d'agents dédiée à la distribution de flyers, échantillons ou coupons sur une zone et des horaires définis, avec briefing du message clé à transmettre au public.",
                "image": distribution,
                "imageAlt": "Agent distribuant des flyers publicitaires dans la rue",
                "specs": [
                { "label": "Équipe", "value": "À partir de 2 agents" },
                { "label": "Zone", "value": "Quartier(s) ou points de passage au choix" },
                { "label": "Durée min.", "value": "1 jour" },
                { "label": "Option", "value": "Compte-rendu avec photos et nombre de flyers distribués" }
                ],
                "ctaLabel": "Réserver ce support",
                "path": "/contact"
            }
        ],
        faq: [
          {
            question: 'Quel est le support publicitaire le moins cher au Bénin ?',
            answer:
              "Le tricycle publicitaire est généralement le support le plus économique pour démarrer une campagne locale, car son rapport coût visibilité sur un mois est supérieur à tous les autres support et ne nécessite pas de production grand format.",
          },
          {
            question: 'Combien de temps dure une campagne sur Panneau Mobile ?',
            answer:
              'La durée minimale varie selon le support, de 4 heures pour un panneau mobile ou un écran digital à 1 mois et plus pour les même supports.',
          },
          {
            question: 'Peut-on combiner plusieurs supports dans une même campagne ?',
            answer:
              "Oui. La plupart de nos clients combinent jusqu'à trois (03) supports pour maximiser la couverture.",
          },
        ],
      };
    },
  
    metaInfo() {
      const baseUrl = 'https://www.panneaumobile.bj';
      const canonical = `${baseUrl}/supports-publicitaires`;
      const title =
        'Supports Publicitaires au Bénin | Panneaux Mobiles, Vélo publicitaire, Tricycle publicitaire, Zémidjans — Panneau Mobile';
      const description =
        "Découvrez tous les supports publicitaires de Panneau Mobile : panneaux mobiles, vélo publicitaire, tricycle publicitaire, façades d'immeubles, panneaux urbains, habillage zémidjan et écrans LED. Devis gratuit sous 24h.";
      const ogImage = `${velo}`;
  
      return {
        title,
        titleTemplate: null,
        htmlAttrs: { lang: 'fr' },
        meta: [
          { charset: 'utf-8' },
          { name: 'description', content: description, vmid: 'description' },
          {
            name: 'keywords',
            content:
              'publicité extérieure Bénin, panneau mobile Cotonou, affichage publicitaire, habillage zémidjan, vélo publicitaire, tricycle publicitaire, moving board, écran LED publicitaire',
            vmid: 'keywords',
          },
          { name: 'robots', content: 'index, follow', vmid: 'robots' },
  
          // Open Graph
          { property: 'og:type', content: 'website', vmid: 'og:type' },
          { property: 'og:title', content: title, vmid: 'og:title' },
          { property: 'og:description', content: description, vmid: 'og:description' },
          { property: 'og:url', content: canonical, vmid: 'og:url' },
          { property: 'og:image', content: ogImage, vmid: 'og:image' },
          { property: 'og:locale', content: 'fr_BJ', vmid: 'og:locale' },
          { property: 'og:site_name', content: 'Panneau Mobile', vmid: 'og:site_name' },
  
          // Twitter
          { name: 'twitter:card', content: 'summary_large_image', vmid: 'twitter:card' },
          { name: 'twitter:title', content: title, vmid: 'twitter:title' },
          { name: 'twitter:description', content: description, vmid: 'twitter:description' },
          { name: 'twitter:image', content: ogImage, vmid: 'twitter:image' },
        ],
        link: [{ rel: 'canonical', href: canonical, vmid: 'canonical' }],
        script: [
          {
            type: 'application/ld+json',
            json: {
              '@context': 'https://schema.org',
              '@type': 'BreadcrumbList',
              itemListElement: [
                { '@type': 'ListItem', position: 1, name: 'Accueil', item: baseUrl },
                {
                  '@type': 'ListItem',
                  position: 2,
                  name: 'Supports publicitaires',
                  item: canonical,
                },
              ],
            },
            vmid: 'ld-breadcrumb',
          },
          {
            type: 'application/ld+json',
            json: {
              '@context': 'https://schema.org',
              '@type': 'ItemList',
              itemListElement: this.supports.map((s, i) => ({
                '@type': 'ListItem',
                position: i + 1,
                item: {
                  '@type': 'Product',
                  name: s.name,
                  description: s.description,
                  image: `${baseUrl}${s.image}`,
                  brand: { '@type': 'Brand', name: 'Panneau Mobile' },
                  url: `${canonical}#${s.slug}`,
                },
              })),
            },
            vmid: 'ld-itemlist',
          },
          {
            type: 'application/ld+json',
            json: {
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: this.faq.map((f) => ({
                '@type': 'Question',
                name: f.question,
                acceptedAnswer: { '@type': 'Answer', text: f.answer },
              })),
            },
            vmid: 'ld-faq',
          },
        ],
      };
    },
  };
  </script>
  
  <style scoped>
  /* ===================================================
     TOKENS
  =================================================== */
  .pm-page {
    --pm-ink: #11131a;
    --pm-paper: #f5efe3;
    --pm-amber: #ffd600;
    --pm-vermilion: #d94f30;
    --pm-teal: #1f6f66;
    --pm-steel: #8b93a1;
  
    --pm-font-display: 'Anton', 'Archivo Black', sans-serif;
    --pm-font-body: 'Poppins', sans-serif;
    --pm-font-mono: 'Poppins', sans-serif;
  
    background: var(--pm-paper);
    color: var(--pm-ink);
    font-family: var(--pm-font-body);
    overflow-x: hidden;
  }
  
  /* ===================================================
     HERO
  =================================================== */
  .pm-hero {
    position: relative;
    min-height: 88vh;
    display: flex;
    align-items: center;
    background: var(--pm-ink);
    overflow: hidden;
  }
  
  .pm-hero__bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.38;
    filter: saturate(0.9) contrast(1.05);
  }
  
  .pm-hero__panel {
    position: relative;
    z-index: 1;
    margin: 4rem auto 4rem 6vw;
    max-width: 640px;
    background: var(--pm-ink);
    border: 3px solid var(--pm-amber);
    padding: clamp(2rem, 4vw, 3.5rem);
    transform: rotate(-1.2deg);
    box-shadow: 14px 14px 0 rgba(232, 163, 61, 0.18);
  }
  
  .pm-hero__bolt {
    position: absolute;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: var(--pm-steel);
    box-shadow: inset 0 0 0 2px var(--pm-ink), inset 0 0 0 3px var(--pm-steel);
  }
  .pm-hero__bolt--tl { top: -7px; left: -7px; }
  .pm-hero__bolt--tr { top: -7px; right: -7px; }
  .pm-hero__bolt--bl { bottom: -7px; left: -7px; }
  .pm-hero__bolt--br { bottom: -7px; right: -7px; }
  
  .pm-hero__eyebrow {
    font-family: var(--pm-font-mono);
    letter-spacing: 0.18em;
    font-size: 0.75rem;
    color: var(--pm-vermilion);
    margin: 0 0 1rem;
  }
  
  .pm-hero__title {
    font-family: var(--pm-font-display);
    font-weight: 400;
    text-transform: uppercase;
    color: var(--pm-paper);
    font-size: clamp(2.1rem, 5vw, 3.6rem);
    line-height: 1.02;
    margin: 0 0 1.25rem;
  }
  
  .pm-hero__subtitle {
    color: #cfd2db;
    font-size: 1.05rem;
    line-height: 1.6;
    margin: 0 0 2rem;
    max-width: 50ch;
  }
  
  /* ===================================================
     BUTTONS
  =================================================== */
  .pm-btn {
    display: inline-block;
    font-family: 'Poppins';
    text-transform: uppercase;
    letter-spacing: 0.06em;
    font-size: 0.85rem;
    text-decoration: none;
    padding: 0.85rem 1.6rem;
    border: 2px solid currentColor;
    transition: transform 0.15s ease, background 0.15s ease, color 0.15s ease;
    border-radius: 5px;
    font-weight: 600;
  }
  .pm-btn--primary {
    color: var(--pm-ink);
    background: var(--pm-amber);
    border-color: var(--pm-amber);
  }
  .pm-btn--primary:hover { transform: translateY(-2px); }
  .pm-btn--secondary {
    color: var(--pm-vermilion);
    background: transparent;
    margin-top: 1.25rem;
  }
  .pm-btn--secondary:hover {
    background: var(--pm-vermilion);
    color: var(--pm-paper);
  }
  
  /* ===================================================
     SECTIONS GENERIC
  =================================================== */
  .pm-main { max-width: 1180px; margin: 0 auto; padding: 0 6vw; }
  
  .pm-section-title {
    font-family: var(--pm-font-display);
    text-transform: uppercase;
    font-weight: 400;
    font-size: clamp(1.6rem, 3vw, 2.3rem);
    margin: 0 0 1.5rem;
  }
  .pm-section-title--light { color: var(--pm-paper); }
  
  .pm-intro { padding: 5rem 0 2rem; max-width: 65ch; }
  .pm-intro__text { font-size: 1.05rem; line-height: 1.7; color: #383b44; }
  
  /* ===================================================
     SUPPORT CARDS
  =================================================== */
  .pm-supports { padding: 2rem 0 5rem; }
  
  .pm-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
    gap: 2rem;
  }
  
  .pm-card {
    position: relative;
    background: #fffdf8;
    border: 2px solid var(--pm-steel);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }
  .pm-card:hover {
    transform: translateY(-4px);
    border: 3px solid var(--pm-ink);
  }
  
  .pm-card__bolt {
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: var(--pm-steel);
    z-index: 2;
  }
  .pm-card__bolt--tl { top: -5px; left: -5px; }
  .pm-card__bolt--br { bottom: -5px; right: -5px; }
  
  .pm-card__media { position: relative; aspect-ratio: 4 / 3; overflow: hidden; }
  .pm-card__media img { width: 100%; height: 100%; object-fit: cover; display: block; }
  
  .pm-card__ref {
    position: absolute;
    bottom: 0;
    left: 0;
    background: var(--pm-ink);
    color: var(--pm-amber);
    font-family: var(--pm-font-mono);
    font-size: 0.7rem;
    letter-spacing: 0.08em;
    padding: 0.3rem 0.6rem;
  }
  
  .pm-card__body { padding: 1.5rem; display: flex; flex-direction: column; flex: 1; }
  
  .pm-card__title {
    font-family: var(--pm-font-display);
    text-transform: uppercase;
    font-weight: 400;
    font-size: 1.25rem;
    margin: 0 0 0.3rem;
  }
  .pm-card__tagline {
    color: var(--pm-vermilion);
    font-size: 0.85rem;
    font-weight: 600;
    margin: 0 0 0.8rem;
  }
  .pm-card__desc {
    font-size: 0.92rem;
    line-height: 1.6;
    color: #383b44;
    margin: 0 0 1.2rem;
  }
  
  .pm-specs { margin: 0 0 0.5rem; border-top: 1px dashed var(--pm-steel); }
  .pm-specs__row {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    padding: 0.45rem 0;
    border-bottom: 1px dashed #d8d2c4;
    font-family: var(--pm-font-mono);
    font-size: 0.78rem;
  }
  .pm-specs__row dt { color: var(--pm-steel); margin: 0; }
  .pm-specs__row dd { margin: 0; text-align: right; font-weight: 600; }
  
  /* ===================================================
     FAQ
  =================================================== */
  .pm-faq { padding: 2rem 0 4rem; max-width: 70ch; }
  .pm-faq__item { padding: 1.25rem 0; border-bottom: 1px solid #d8d2c4; }
  .pm-faq__question { font-size: 1.05rem; margin: 0 0 0.5rem; }
  .pm-faq__answer { font-size: 0.95rem; line-height: 1.6; color: #383b44; margin: 0; }
  
  /* ===================================================
     CTA FINAL
  =================================================== */
  .pm-cta {
    background: var(--pm-ink);
    margin: 0 -6vw;
    padding: 4.5rem 6vw;
    text-align: center;
  }
  .pm-cta__text {
    color: #cfd2db;
    max-width: 50ch;
    margin: 0 auto 2rem;
    line-height: 1.6;
  }
  
  /* ===================================================
     RESPONSIVE / ACCESSIBILITY
  =================================================== */
  @media (max-width: 640px) {
    .pm-hero__panel { margin: 3rem 4vw; transform: rotate(0); }
  }
  
  @media (prefers-reduced-motion: reduce) {
    .pm-card, .pm-btn { transition: none; }
  }
  
  .pm-btn:focus-visible,
  a:focus-visible {
    outline: 3px solid var(--pm-teal);
    outline-offset: 2px;
  }
  </style>